'use strict';

export const Constants = Object.freeze({
  DAYS: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  NO_DATA_MESSAGES: {
    noActivities: 'No activities recorded.',
    expiredActivities:
      'No activity log is present. We only keep the activity log information for [days] days.',
    noFilteredActivities:
      'No result. You may want to try using different keywords, checking for typos, or adjusting your filters.',
  },
  USER_TYPES: {
    USER: 'user',
    PLATFORM: 'purespectrum platform',
    API: 'api',
  },
});
